import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import {
  FileTextOutlined, SwapOutlined, DatabaseOutlined,
  UserOutlined, SettingOutlined,
  RightOutlined, LogoutOutlined,
} from '@ant-design/icons';
import api from '../api';
import { clearSessionPlainPassword } from '../sessionPlainPassword';
import { getStoredUser, isRegionManager } from '../userAuth';

export default function Profile() {
  const navigate = useNavigate();
  const user = getStoredUser();
  const [stats, setStats] = useState({ applies: 0, borrows: 0, assets: 0 });
  const isRegionAdmin = isRegionManager(user);

  useEffect(() => {
    Promise.all([
      api.get('/applies', { params: { status: 0, page: 1, page_size: 1 } }).catch(() => null),
      api.get('/borrows/mine', { params: { status: 1, page: 1, page_size: 1 } }).catch(() => null),
      api.get('/dashboard/stats').catch(() => null),
    ]).then(([applyRes, borrowRes, dashRes]) => {
      const borrowCount = Array.isArray(borrowRes) ? borrowRes.length : 0;
      setStats({
        applies: applyRes?.total || 0,
        borrows: borrowCount,
        assets: dashRes?.my_assets || 0,
      });
    });
  }, []);

  const menuItems = [
    { label: '我的申请', icon: <FileTextOutlined />, path: '/my-applies' },
    { label: '我的借用', icon: <SwapOutlined />, path: '/return', badge: stats.borrows },
    { label: '我的资产', icon: <DatabaseOutlined />, path: user?.id ? `/assets?user_id=${user.id}` : '/assets' },
    ...(isRegionAdmin ? [{ label: '我的区域', icon: <DatabaseOutlined />, path: '/assets?managed=1' }] : []),
    { label: '我的信息', icon: <UserOutlined />, path: '/profile/my-info' },
  ];

  const handleLogout = () => {
    localStorage.clear();
    clearSessionPlainPassword();
    message.success('已退出');
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', maxWidth: 750, margin: '0 auto' }}>
      {/* Blue header card */}
      <div style={{
        background: 'linear-gradient(135deg, #1677FF 0%, #4096ff 100%)',
        borderRadius: '0 0 24px 24px',
        padding: '40px 20px 30px',
        position: 'relative',
      }}>
        {/* Settings icon */}
        <SettingOutlined
          onClick={() => navigate('/profile/settings')}
          style={{
            position: 'absolute', top: 16, right: 16,
            fontSize: 20, color: 'rgba(255,255,255,0.8)', cursor: 'pointer',
          }}
        />
        {/* Avatar */}
        <div style={{
          width: 64, height: 64, borderRadius: 32,
          background: 'rgba(255,255,255,0.9)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 12px',
        }}>
          <UserOutlined style={{ fontSize: 30, color: '#1677FF' }} />
        </div>
        {/* Name */}
        <div style={{ textAlign: 'center', color: '#fff', fontSize: 20, fontWeight: 700 }}>
          {user.username || '用户'}
        </div>
        {/* Work no */}
        <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.8)', fontSize: 14, marginTop: 4 }}>
          工号: {user.work_no || '-'}
        </div>
      </div>

      {/* Stats row */}
      <div style={{
        background: '#fff', borderRadius: 12, margin: '-16px 16px 12px',
        padding: '18px 0', display: 'flex', position: 'relative', zIndex: 2,
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      }}>
        {[
          { count: stats.applies, label: '我的申请' },
          { count: stats.borrows, label: '我的借用' },
          { count: stats.assets, label: '我的资产' },
        ].map((item, i) => (
          <div key={i} style={{
            flex: 1, textAlign: 'center',
            borderRight: i < 2 ? '1px solid #f0f0f0' : 'none',
          }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#333' }}>{item.count}</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{item.label}</div>
          </div>
        ))}
      </div>

      {/* Menu list */}
      <div style={{
        background: '#fff', borderRadius: 12, margin: '0 16px 12px',
        overflow: 'hidden',
      }}>
        {menuItems.map((item, i) => (
          <div key={item.path} onClick={() => navigate(item.path)}
            style={{
              display: 'flex', alignItems: 'center', padding: '14px 16px',
              cursor: 'pointer', borderBottom: i < menuItems.length - 1 ? '1px solid #f5f5f5' : 'none',
            }}>
            <span style={{ fontSize: 18, color: '#1677FF', marginRight: 12, width: 24, textAlign: 'center' }}>
              {item.icon}
            </span>
            <span style={{ flex: 1, fontSize: 15, color: '#333' }}>{item.label}</span>
            {item.badge > 0 && (
              <span style={{
                background: '#ff4d4f', color: '#fff', fontSize: 11,
                padding: '1px 6px', borderRadius: 10, marginRight: 8, fontWeight: 500,
              }}>
                {item.badge}
              </span>
            )}
            <RightOutlined style={{ fontSize: 12, color: '#ccc' }} />
          </div>
        ))}
      </div>

      {/* Logout */}
      <div style={{ margin: '0 16px 30px' }}>
        <div onClick={handleLogout} style={{
          background: '#fff', borderRadius: 12, padding: '14px 0',
          textAlign: 'center', cursor: 'pointer',
          color: '#ff4d4f', fontSize: 15, fontWeight: 500,
          border: '1px solid #ffccc7',
        }}>
          <LogoutOutlined style={{ marginRight: 6 }} />
          退出登录
        </div>
      </div>
    </div>
  );
}
